<template>
    <div class="custom-field" v-if="viewPage && !isInquiry" style="padding: 10px 0px; ">

       <span v-if="isSignature">
            <span  style="font-size: 14px; font-weight: 500;">{{ value.question_text }}: </span>
            <span><img :src="value.answer_text_names" width="140px" class="image-bigpic"></span>
        </span>

        <span v-else>
            <span style="font-size: 14px; font-weight: 500;">{{ value.question_text }}: </span>
            <span style="font-size: 14px; font-weight: 400;">{{ value.answer_text_names != 0 ? value.answer_text_names : '' }}</span>
        </span>

    </div>
    <div class="custom-field " :class="{'row': isInquiry}" style="margin-bottom: 15px;" v-else>

        <form-longtext v-if="isLongText && !question.is_deleted" v-model="question"  :view-page="viewPage" :is-inquiry="isInquiry" :inquiry-id="inquiryId"></form-longtext>
        <form-button-group v-else-if="isGroupButton && !question.is_deleted" v-model="question" :view-page="viewPage" :is-inquiry="isInquiry" :inquiry-id="inquiryId"></form-button-group>
        <form-toggle v-else-if="isCheckbox && !question.is_deleted" v-model="question"   :view-page="viewPage" :is-inquiry="isInquiry" :inquiry-id="inquiryId"></form-toggle>
        <form-text v-else-if="isTextBox && !question.is_deleted" v-model="question"   :view-page="viewPage" :is-inquiry="isInquiry" :inquiry-id="inquiryId"></form-text>
        <form-time v-else-if="isTime && !question.is_deleted" v-model="question" :time-format="timeFormat"  :view-page="viewPage" :is-inquiry="isInquiry" :inquiry-id="inquiryId"></form-time>
        <form-radio-button v-else-if="isEnum && !question.is_deleted" v-model="question"  :view-page="viewPage" :is-inquiry="isInquiry" :inquiry-id="inquiryId"></form-radio-button>
        <form-checkbox v-else-if="isSet && !question.is_deleted" v-model="question" :view-page="viewPage" :is-inquiry="isInquiry" :inquiry-id="inquiryId"></form-checkbox>
        <form-date v-else-if="isDate && !question.is_deleted" :date-format="dateFormat" v-model="question" :view-page="viewPage" :is-inquiry="isInquiry" :inquiry-id="inquiryId"></form-date>
        <form-plus-minus v-else-if="isPlusMinus && !question.is_deleted" v-model="question"  :view-page="viewPage" :is-inquiry="isInquiry" :inquiry-id="inquiryId"></form-plus-minus>
        <form-drop-down v-else-if="isDropdown && !question.is_deleted" v-model="question"  :view-page="viewPage" :is-inquiry="isInquiry" :inquiry-id="inquiryId"></form-drop-down>
        <form-List v-else-if="isList && !question.is_deleted" v-model="question"  :view-page="viewPage" :is-inquiry="isInquiry" :inquiry-id="inquiryId"></form-List>
        <form-signature v-else-if="isSignature && !question.is_deleted" v-model="question" :s3-path="s3Path"   :view-page="viewPage" :is-inquiry="isInquiry" :inquiry-id="inquiryId"></form-signature>
    </div>
</template>

<script>

import {EventBus} from "../../../events/event-bus";
import {getAvailableForms} from "@/modules/Forms/api"
import {updateFormQuestionOnViewInquiry} from "@/events/sharedMethods.js";

const ENUM = "Enum"
const LONGTEXT = "long_text"
const CHECKBOX = "checkbox"
const TEXT_BOX = "text_input"
const TIME = "time"
const SET = "set"
const DATE_INPUT = "date";
const TEXT = "text";
const DROPDOWN = "dropdown"
const LIST = "multiselect"
const SIGNATURE = "signature"

export default {

    name: "Question",
    props: {
        value: {
            type: Object
        },
        services: {
            type: Array,
            default() {
                return []
            }
        },
        dateFormat: {},
        timeFormat: {},
        s3Path: {
            type: String,
            default() {
                return '';
            }
        },
        viewPage: false,
        itemId: null,
        formId: null,
        isInquiry: {
            default() {
                return 0
            }
        },
        inquiryId:0
    },
    data() {
        return {
            question: {
                ...this.value,
                value: '',
                contractors:[],
            }
        }
    },
    mounted() {
        this.addEventListeners()
        this.$nextTick(() => {
            this.$emit('questionMounted');
        })
    },
    methods: {
        addEventListeners() {
            EventBus.$on('onUpdateFormAndCheckList', () => {
                this.question = {...this.value}
            })
        },
    },
    computed: {
        isGroupButton() {
            return this.question.attribute_type === ENUM && this.question.is_new === 1
        },
        isLongText() {
            return this.question.attribute_type === LONGTEXT
        },
        isCheckbox() {
            return this.question.attribute_type === CHECKBOX
        },
        isTextBox() {
            return this.question.attribute_type === TEXT_BOX && this.question.is_new === 0;
        },
        isTime() {
            return this.question.attribute_type === TIME
        },
        isEnum() {
            return this.question.attribute_type === ENUM && this.question.is_new === 0;
        },
        isSet() {
            return this.question.attribute_type === SET
        },
        isDropdown() {
            return this.question.attribute_type === DROPDOWN && this.question.is_new === 0;
        },
        isList() {
            return this.question.attribute_type === LIST && this.question.is_new === 0;
        },
        isDate() {
            return this.question.attribute_type === DATE_INPUT;
        },
        isPlusMinus() {
            return this.question.attribute_type === TEXT_BOX && this.question.is_new === 1;
        },
        isSignature() {
            return this.question.attribute_type === SIGNATURE;
        },
    },
    watch: {
        question: {
            handler(question) {
                this.$emit('input', question)
            },
            deep: true
        }
    }
}
</script>